
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/evo-icl-is-worth-the-wait",
      function () {
        return require("private-next-pages/evo-icl-is-worth-the-wait.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/evo-icl-is-worth-the-wait"])
      });
    }
  